import { Collapse, Descriptions, Table, Typography } from 'antd'
import styled from 'styled-components'

import { SourceContextSection } from './sourceContext'

const SectionContent = styled.div`
  display: grid;
  gap: 1rem;
  min-width: 0;

  .ant-table-cell,
  .ant-descriptions-item-content {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    vertical-align: top;
  }
`

export const CapturedAssessmentDetails = ({
  title,
  sections,
}: {
  title: string
  sections: SourceContextSection[] | undefined
}) => (
  <div>
    <Typography.Title level={4}>{title}</Typography.Title>
    {sections ? (
      <Collapse
        items={sections.map((section) => ({
          key: section.id,
          label: section.title,
          children: (
            <SectionContent>
              {section.rows.length > 0 && (
                <Descriptions
                  column={1}
                  bordered
                  size='small'
                  items={section.rows.map((row, index) => ({
                    key: index,
                    label: row.label,
                    children: row.value,
                  }))}
                />
              )}
              {section.tables.map((table, index) => (
                <div key={index}>
                  {table.title !== section.title && (
                    <Typography.Title level={5}>{table.title}</Typography.Title>
                  )}
                  <Table
                    size='small'
                    bordered
                    pagination={false}
                    scroll={{ x: true }}
                    columns={table.columns.map((column) => ({
                      key: column.key,
                      dataIndex: column.key,
                      title: column.title,
                    }))}
                    dataSource={table.records.map((values, rowIndex) => ({
                      ...values,
                      key: rowIndex,
                    }))}
                  />
                </div>
              ))}
            </SectionContent>
          ),
        }))}
      />
    ) : (
      <Typography.Paragraph type='secondary'>
        Full source context was not captured for this plan. Its existing
        assessment summary and zones remain available.
      </Typography.Paragraph>
    )}
  </div>
)
